import { CachePolicy } from 'contentstack';
import { unstable_cache } from 'next/cache';

import { logger } from '@/services/logger';
import {
    ContentStack,
    ContentStackLivePreview,
} from '@nxt-costco-com/forge-digital-components';
import type {
    ContentTypeProps,
    LocaleProps,
} from '@nxt-costco-com/forge-digital-components';

const _getConfigurationSettingByDeveloperKey = async <T>(
    contentType: ContentTypeProps,
    developmentKey: string,
    locale: LocaleProps,
    enableLivePreview = false,
): Promise<T | undefined> => {
    let stackClient = ContentStack;

    if (enableLivePreview) {
        stackClient = ContentStackLivePreview;
        stackClient.setCachePolicy(CachePolicy.IGNORE_CACHE);
    }

    try {
        const query = stackClient.stack
            .ContentType(contentType)
            .Query()
            .where('development_key', developmentKey)
            .language(locale)
            .toJSON()
            .findOne();
        const result = await query;
        return result;
    } catch (err) {
        logger.error(err);
        throw new Error(
            `An error occurred in _getConfigurationSettingByDeveloperKey.
        contentType: ${contentType},
        developmentKey: ${developmentKey},
        locale: ${locale},
        enableLivePreview: ${enableLivePreview}
        ${JSON.stringify(err, null, 2)}`,
        );
    }
};

const cached_getConfigurationSettingByDeveloperKey = unstable_cache(
    _getConfigurationSettingByDeveloperKey,
    ['search_getConfigurationSettingByDeveloperKey'],
    { revalidate: 1800 },
);

export const getConfigurationSettingByDeveloperKey = async <T>(
    contentType: ContentTypeProps,
    developmentKey: string,
    locale: LocaleProps,
    enableLivePreview = false,
): Promise<T> => {
    const fn =
        typeof window === 'undefined'
            ? cached_getConfigurationSettingByDeveloperKey
            : _getConfigurationSettingByDeveloperKey;

    return fn(contentType, developmentKey, locale, enableLivePreview) as T;
};
